import styled from 'styled-components'

import { Flex } from 'Components/UI'

import { LANDING_INLINE_PADDINGS, PY_BLUEPRINT } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  my: PY_BLUEPRINT,
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
`

export const Content = styled(Flex).attrs({
  my: [50, 65],
})`
  flex-direction: column;
  align-items: center;
  max-width: 700px;
`

export const ButtonWrapper = styled(Flex).attrs({
  mt: [18, 30],
})``
